<template>
  <div class="verifyMainPage">
    <h4 class="spTit">审批</h4>
    <div class="buttonCodeBox clearfix dis_flex">
      <!-- <span class="fl Htitle van-cell--required">审批状态：</span> -->
      <van-cell title="审批状态：" required readonly class="baseQ" />
      <van-radio-group style="flex-shrink: 0;"
      :required="!disType"
        v-model="verifyData.buttonCode"
        direction="horizontal"
        class="clearfix radioBox fl"
      >
        <van-radio name="pass" class="fl"
          >同意</van-radio
        >
      </van-radio-group>
    </div>
    <van-cell-group class="baseNone baseSalary moreText" v-if="applicantData.currentStep=='1'">
      <van-field
        v-model="verifyData.marketHeadName"
        label="营销负责人"
        :required="!disType"
        :placeholder="!disType ? '请选择' : ''"
        :is-link="!disType"
        @click="checkRedioRetinuePicker('1')"
        readonly
      />
      <van-field
        v-model="verifyData.firstContactName"
        label="第一次联系人"
        :required="!disType"
        :placeholder="!disType ? '请选择' : ''"
        :is-link="!disType"
        @click="checkMoreRetinuePicker"
        readonly
      />
    </van-cell-group>

    <van-cell-group class="baseNone baseSalary moreText" v-if="applicantData.currentStep=='2'">
      <van-field
        v-model="verifyData.nextStepName"
        label="实施部门经理：" 
        :required="!disType"
        :placeholder="!disType ? '请选择' : ''"
        :is-link="!disType"
        @click="changeChildDept"
        readonly
      />
    </van-cell-group>
    <van-cell-group class="baseNone baseSalary moreText" v-if="applicantData.currentStep=='3'">
      <van-field
        v-model="verifyData.nextStepName"
        label="项目经理：" 
        :required="!disType"
        :placeholder="!disType ? '请选择' : ''"
        :is-link="!disType"
        @click="checkRedioRetinuePicker('3')"
        readonly
      />
    </van-cell-group>
    <van-cell-group>
      <!-- <p>审批意见：</p> -->
      <van-field
      label='审批意见：'
        v-model="verifyData.message"
        @input="chnageMessage(verifyData.message)"
        rows="2"
        autosize
        :readonly="disType"
        :required="verifyData.buttonCode == 'reject' && disType"
        class="message"
        type="textarea"
        placeholder="请填写审批意见"
      />
    </van-cell-group>
    <div class="zgcBg" v-if="this.verifyType == '2'"></div>
    <div class="btnBox" v-if="verifyType == '1'">
      <van-button type="info" @click="checkInput()">提交</van-button>
    </div>

    <!-- 弹出框 -->
    <!-- 选择营销负责人 -->
    <van-popup
      v-model="showRedioRetinuePicker"
      position="bottom"
      class="roleBox"
    >
      <redio-retinue-view
        :retinueUid="redioWhetherId"
        @setReview="setRedioRetinue"
      ></redio-retinue-view>
    </van-popup>
    <van-popup
    v-model="showMoreRetinuePicker"
    position="bottom"
    class="roleBox"
  >
    <more-retinue-view
    :retinueUids="verifyData.firstContact"
    @moreSetReview="setMoreRetinue"
  ></more-retinue-view>
  </van-popup>

  <!--  适用部门 -->
  <van-popup v-model="showChildDeptPicker" position="bottom" class="roleBox">
    <dept-view :retinueUid="deptId"  @setDeptData="setDepts"></dept-view>
  </van-popup>
  </div>
</template>
<script>
/* eslint-disable */
const redioRetinueView = () =>
  import("@/components/businessTripMould/redioRetinueView");
const moreRetinueView = () =>
import("@/components/businessTripMould/moreRetinueView");
const deptView = () => import("@/components/common/depUsertList");

import newApi from "lodash";
import { dateFormat, getDictList, isEdit } from "@/utils/common";
import { getDeviceType, closePage ,is_wei} from "@/common/getDeviceType/getDeviceType";
export default {
  name: "verifyMain",
  components: {redioRetinueView,moreRetinueView,deptView},
  data() {
    return {
      showChildDeptPicker:false,
      redioWhetherId:'',//营销负责人'1'和第一次业主联系人'2''id
      redioWhetherIndex:'',//营销负责人'1'和第一次业主联系人'2''
      showRedioRetinuePicker:false,// 营销负责人弹框
      showMoreRetinuePicker:false,//第一次负责人多选
      verifyType: "", //判断是否已审核
      disType: false, //是否可编辑

      verifyData: {
        buttonCode: "pass", //审批状态
        firstContact:[],//第一次业主联系人
        firstContactName:"",
        marketHead:"",//营销人员
        marketHeadName:"",
        message: "", //审批意见
        nextStep:"",//下一步审核人
        nextStepName:""
      },
      deptId:'',
    };
  },
  props: {
    applicantData: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  mounted() {
    this.verifyType = this.$route.query.verifyType; //
    if (this.applicantData) {
      this.disType = this.verifyType == "1" ? false : true;
    }
  },
  methods: {
    changeChildDept() {
      //选择适用部门
      if (!this.disType) {
        this.showChildDeptPicker = true;
      }
    },
    setDepts(data) {
      if (data != "") {
        this.$set(this.verifyData, "nextStep", data.staffList[0].uid);
        this.$set(this.verifyData, "nextStepName",data.staffList[0].realName);
        this.deptId=data.depId
      }
      this.showChildDeptPicker = false;
    },
    // 营销负责人选中
      setRedioRetinue(data) {
      if (data != "") {
        if(this.redioWhetherIndex=='1'){
          this.verifyData.marketHeadName = data.realName;
          this.verifyData.marketHead = data.id;
          this.$set(this.verifyData,'marketHead',data.id)
        }else if(this.redioWhetherIndex=='2'){
          this.verifyData.firstContactName = data.realName;
          this.verifyData.firstContact = data.id;
          this.$set(this.verifyData,'firstContact',data.id)
        }else{
          this.verifyData.nextStepName = data.realName;
          this.$set(this.verifyData,'nextStep',data.id)
        }
        
      }
      this.showRedioRetinuePicker = false;
    },
    //营销负责人
    checkRedioRetinuePicker(type) {
      if(!this.disType){
        this.redioWhetherIndex=type;
        if(type=='1'){
          this.redioWhetherId=this.verifyData.marketHead;
        }else if(type=='3'){
          this.redioWhetherId=this.verifyData.nextStep;
        }
        this.showRedioRetinuePicker = true;
      }
    },
    checkMoreRetinuePicker(){
      if(!this.disType){
        this.showMoreRetinuePicker = true;
      }
    },
    setMoreRetinue(data) {
      this.verifyData.firstContact = [];
      let firstContactName=[];
      let newArr = JSON.parse(window.sessionStorage.getItem("moreRetinueList"));
      newArr.forEach((item) => {
        this.verifyData.firstContact.push(item.id);
        firstContactName.push(item.realName);
      });
      this.verifyData.firstContactName=firstContactName.join(",");
      this.showMoreRetinuePicker = false;
    },
    checkInput() {
      if (
        (
          this.applicantData.currentStep=='1'&&(
          this.verifyData.firstContact == "" ||
          this.verifyData.marketHead == "" 
        )
        )||
        (
          (this.applicantData.currentStep=='2' || this.applicantData.currentStep=='3')&&
          this.verifyData.nextStep == "" 
        )
        
      ) {
        this.$toast("带星号为必填项, 不能为空");
      } else {
        this.saveVerify();
      }
    },
    chnageMessage(val) {
      this.verifyData.message = val;
    },
    saveVerify() {
      let _this = this;
      let params={};
      if(_this.applicantData.currentStep=='1'){
        params={
          registerId:_this.applicantData.id,
          auditResult:_this.verifyData.buttonCode,
          firstContact:_this.verifyData.firstContact,
          marketHead:_this.verifyData.marketHead,
          message:_this.verifyData.message,
        }
      }else if(_this.applicantData.currentStep=='2' || _this.applicantData.currentStep=='3'){
        let nextStepIds=[];
        nextStepIds.push(_this.verifyData.nextStep)
        params={
          registerId:_this.applicantData.id,
          auditResult:_this.verifyData.buttonCode,
          nextStepIds:nextStepIds,
          message:_this.verifyData.message,
        }
      }else{
        params={
          registerId:_this.applicantData.id,
          auditResult:_this.verifyData.buttonCode,
          message:_this.verifyData.message,
        }
      }
      _this.$api.project.audit(params)
        .then((res) => {
          if (res.code == "1") {
            console.log(res.data);
            let text = "提交审批成功";
            if (is_wei()) {
              _this.$toast(text);
              this.$emit("changeVerifyType", "1");
            } else {
              closePage(text);
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  watch: {
    applicantData: {
      handler: function (val) {
        if (val) {
          this.verifyType == "1"
            ? (this.disType = true)
            : (this.disType = false);
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.roleBox {
  background-color: rgba(255,255,255,1);
}
.verifyMainPage {
  width: 100%;
  min-height: 450px;
  padding-top: 45px;
  position: relative;
  .baseNone.itemPerson {
    .van-field__body {
      .van-field__control {
        text-align: right;
        color: #969799;
      }
    }
  }

  .spTit {
    width: 100%;
    color: #333;
    text-align: center;
    position: absolute;
    top: 15px;
  }
  .zgcBg {
    width: 100%;
    height: 50px;
    position: absolute;
    top: 60px;
    left: 0;
  }
  p {
    font-size: 14px;
    padding: 0 16px;
    color: #333;
  }
  .ggInput.van-cell::after{
    content:none
  }
  .ggInput{
       border-bottom: 1px solid #ebedf0;
  }
  .baseNone {
    .van-cell__title {
      span {
        font-size: 14px;
      }
    }
    .van-field__body {
      .van-field__control {
        color: #969799;
        font-size: 14px;
        text-indent: 2em;
      }
    }
  }
  .message.van-cell--required::before {
    top: -20px;
  }
  .baseNone.beizhu {
    padding-top: 8px;
    min-height: 45px;
    .van-field__body {
      .van-field__control {
        text-align: left;
      }
    }
  }
  .radioBox {
    padding: 0 16px;
    .van-radio {
      height: 45px;
      .van-radio__label {
        font-size: 14px;
        color: #969799;
        line-height: 16px;
      }
    }
  }
  .expensesTypeBox,.buttonCodeBox {
    border-bottom: 1px solid #ebedf0;
    
    // position: relative;
    span.title,span.Htitle {
      display: block;
      width: 90px;
      font-size: 14px;
      padding-left: 16px;
      color: #333;
      line-height: 45px;
    }
    span.title::before {
      position: absolute;
      left: 2.133vw;
      color: #ee0a24;
      font-size: 3.733vw;
      content: "*";
    }
  }
 
}
</style>